export default __webpack_public_path__ + "static/media/jbl.8c69c59e.png";